import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';
import BookingCalendar from '../../components/feature/BookingCalendar';

export default function ContrattoPage() {
  const [showBooking, setShowBooking] = useState(false);
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        {/* Hero Section */}
        <section className="bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 py-20">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <div className="w-20 h-20 bg-indigo-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
                <i className="ri-file-text-fill text-3xl text-white"></i>
              </div>
              <h1 className="text-5xl font-bold text-gray-900 mb-6">
                Redazione Contratto Personalizzato
              </h1>
              <p className="text-xl text-gray-700 max-w-3xl mx-auto mb-8">
                Creazione di un contratto di locazione su misura per la tua situazione specifica, 
                conforme alle normative vigenti e ottimizzato per le tue esigenze.
              </p>
              <Button size="lg" className="cursor-pointer bg-indigo-600 hover:bg-indigo-700" onClick={() => setShowBooking(true)}>
                Richiedi Contratto Personalizzato
              </Button>
            </div>
          </div>
        </section>

        {/* Garanzia Soddisfatti o Non Paghi */}
        <section className="py-16 bg-gradient-to-r from-amber-500 via-orange-500 to-red-500">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center text-white">
              <div className="w-16 h-16 bg-white/30 rounded-full flex items-center justify-center mx-auto mb-6 shadow-xl">
                <i className="ri-shield-star-fill text-4xl text-white"></i>
              </div>
              <h2 className="text-3xl font-bold mb-4">
                Nessun Pagamento Anticipato - Paghi Solo se Sei Soddisfatto
              </h2>
              <p className="text-xl text-white/95 mb-6 max-w-3xl mx-auto">
                La preparazione del contratto NON richiede alcun pagamento anticipato. 
                Al termine della redazione, potrai valutare il servizio ricevuto e decidere liberamente:
              </p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
                <div className="bg-white/20 backdrop-blur-sm rounded-xl p-6 border-2 border-white/40 shadow-lg">
                  <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-md">
                    <i className="ri-check-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-3">Se Sei Soddisfatto</h3>
                  <p className="text-white/95">
                    Procedi con il pagamento di €75 e ricevi immediatamente il tuo contratto personalizzato pronto per la firma
                  </p>
                </div>
                <div className="bg-white/20 backdrop-blur-sm rounded-xl p-6 border-2 border-white/40 shadow-lg">
                  <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-md">
                    <i className="ri-close-line text-2xl text-white"></i>
                  </div>
                  <h3 className="text-xl font-bold mb-3">Se Non Sei Soddisfatto</h3>
                  <p className="text-white/95">
                    Non paghi nulla e il contratto non verrà inviato. Nessun costo, nessun impegno, nessun problema
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Sezione Servizi */}
        <section id="servizi" className="py-20 bg-gradient-to-b from-white to-gray-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Tipi di Contratto Disponibili
              </h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              <div className="bg-white rounded-xl p-6 shadow-xl border-2 border-transparent hover:border-indigo-500 hover:shadow-2xl transition-all">
                <div className="w-12 h-12 bg-indigo-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-home-4-line text-2xl text-indigo-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Contratto Libero (4+4)</h3>
                <p className="text-gray-700 mb-4">Durata 4 anni rinnovabili per altri 4. Canone liberamente concordato tra le parti.</p>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Canone di mercato</li>
                  <li>• Maggiore flessibilità</li>
                  <li>• Durata 8 anni totali</li>
                  <li>• Cedolare secca opzionale</li>
                </ul>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-xl border-2 border-transparent hover:border-teal-500 hover:shadow-2xl transition-all">
                <div className="w-12 h-12 bg-teal-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-price-tag-3-line text-2xl text-teal-600"></i>
                </div>
                <div className="flex justify-between items-start mb-3">
                  <h3 className="text-xl font-bold text-gray-900">Contratto Concordato (3+2)</h3>
                  <span className="bg-amber-100 text-amber-800 text-xs font-semibold px-2 py-1 rounded-full whitespace-nowrap">
                    Solo TV/PN
                  </span>
                </div>
                <p className="text-gray-700 mb-4">Durata 3 anni rinnovabili per altri 2. Canone calmierato secondo accordi territoriali.</p>
                <div className="bg-amber-50 border border-amber-200 rounded-lg p-3 mb-4">
                  <p className="text-amber-800 text-sm font-medium">
                    <i className="ri-map-pin-line mr-2"></i>
                    Disponibile solo per Province di Treviso e Pordenone
                  </p>
                </div>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Canone ridotto</li>
                  <li>• Agevolazioni fiscali</li>
                  <li>• Durata 5 anni totali</li>
                  <li>• Cedolare secca ridotta</li>
                </ul>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-xl border-2 border-transparent hover:border-purple-500 hover:shadow-2xl transition-all">
                <div className="w-12 h-12 bg-purple-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-time-line text-2xl text-purple-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Contratto Transitorio</h3>
                <p className="text-gray-700 mb-4">Durata da 1 a 18 mesi per esigenze temporanee documentate di proprietario o inquilino.</p>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Durata flessibile</li>
                  <li>• Per esigenze temporanee</li>
                  <li>• Motivazione documentata</li>
                  <li>• Non rinnovabile automaticamente</li>
                </ul>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-xl border-2 border-transparent hover:border-blue-500 hover:shadow-2xl transition-all">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-graduation-cap-line text-2xl text-blue-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Contratto per Studenti Universitari</h3>
                <p className="text-gray-700 mb-4">Contratto specifico per studenti universitari con durata da 6 mesi a 3 anni, rinnovabile.</p>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Durata flessibile 6-36 mesi</li>
                  <li>• Canone agevolato</li>
                  <li>• Rinnovo automatico previsto</li>
                  <li>• Ideale per fuori sede</li>
                </ul>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-xl border-2 border-transparent hover:border-orange-500 hover:shadow-2xl transition-all">
                <div className="w-12 h-12 bg-orange-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-suitcase-line text-2xl text-orange-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Contratto per Uso Turistico</h3>
                <p className="text-gray-700 mb-4">Contratto per locazioni brevi turistiche fino a 30 giorni, ideale per affitti vacanze.</p>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Durata massima 30 giorni</li>
                  <li>• Finalità turistica</li>
                  <li>• Gestione semplificata</li>
                  <li>• Codice identificativo regionale</li>
                </ul>
              </div>
              <div className="bg-white rounded-xl p-6 shadow-xl border-2 border-transparent hover:border-emerald-500 hover:shadow-2xl transition-all">
                <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center mb-4">
                  <i className="ri-store-2-line text-2xl text-emerald-600"></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">Contratto per Uso Commerciale</h3>
                <p className="text-gray-700 mb-4">Contratto per locazione di immobili ad uso commerciale, uffici, negozi e attività.</p>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Durata 6+6 anni</li>
                  <li>• Per attività commerciali</li>
                  <li>• Canone indicizzato ISTAT</li>
                  <li>• Rinnovo automatico 6 anni</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Processo di Redazione */}
        <section className="py-20 bg-gradient-to-br from-indigo-50 to-purple-50">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div className="bg-cover bg-center rounded-xl h-96 shadow-2xl" style={{
                backgroundImage: `url('/images/contratto-detail.jpg')`
              }}></div>
              <div>
                <h2 className="text-3xl font-bold text-gray-900 mb-6">
                  Il Nostro Processo di Redazione
                </h2>
                <div className="space-y-6">
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-indigo-600 rounded-full flex items-center justify-center mr-4 mt-1 shadow-md">
                      <span className="text-white font-bold">1</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Raccolta Informazioni</h3>
                      <p className="text-gray-700">Analizziamo la tua situazione specifica e le esigenze da soddisfare
</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-teal-600 rounded-full flex items-center justify-center mr-4 mt-1 shadow-md">
                      <span className="text-white font-bold">2</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Scelta Tipologia</h3>
                      <p className="text-gray-700">Selezioniamo insieme il tipo di contratto più vantaggioso per il tuo caso</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-purple-600 rounded-full flex items-center justify-center mr-4 mt-1 shadow-md">
                      <span className="text-white font-bold">3</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Redazione Personalizzata</h3>
                      <p className="text-gray-700">Creiamo il contratto su misura con clausole specifiche per la tua situazione</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <div className="w-8 h-8 bg-blue-600 rounded-full flex items-center justify-center mr-4 mt-1 shadow-md">
                      <span className="text-white font-bold">4</span>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">Revisione e Consegna</h3>
                      <p className="text-gray-700">Revisione finale del documento e consegna del contratto pronto per la firma</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Documenti base Necessari per la Preparazione */}
        <section className="py-20 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-16">
              <h2 className="text-3xl font-bold text-gray-900 mb-4">
                Documenti base Necessari per la Preparazione
              </h2>
              <p className="text-xl text-gray-700">
                Ecco i documenti che conduttore e locatore devono rendere disponibili durante la videoconferenza
              </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              <div className="bg-gradient-to-br from-indigo-50 to-blue-50 rounded-xl p-8 shadow-xl border-2 border-indigo-200">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                  <i className="ri-home-4-line text-indigo-600 mr-3"></i>
                  Documenti del Locatore (Proprietario)
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <i className="ri-file-text-line text-indigo-600 mr-3 mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Documento di identità</h4>
                      <p className="text-gray-700 text-sm">Carta d'identità o passaporto in corso di validità</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-file-text-line text-indigo-600 mr-3 mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Codice fiscale</h4>
                      <p className="text-gray-700 text-sm">Tessera sanitaria o documento equivalente</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-map-pin-line text-indigo-600 mr-3 mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Indirizzo completo e dati catastali</h4>
                      <p className="text-gray-700 text-sm">Indirizzo dell'immobile e dati catastali (foglio, particella, subalterno)</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-home-smile-line text-indigo-600 mr-3 mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Stato di arredamento</h4>
                      <p className="text-gray-700 text-sm">Se presente arredo, è consigliabile identificarlo</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-leaf-line text-indigo-600 mr-3 mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Attestato di Prestazione Energetica (APE)</h4>
                      <p className="text-gray-700 text-sm">Certificazione energetica in corso di validità</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-bank-line text-indigo-600 mr-3 mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Coordinate bancarie</h4>
                      <p className="text-gray-700 text-sm">IBAN per il versamento del canone di locazione</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-teal-50 to-emerald-50 rounded-xl p-8 shadow-xl border-2 border-teal-200">
                <h3 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
                  <i className="ri-user-heart-line text-teal-600 mr-3"></i>
                  Documenti del Conduttore (Inquilino)
                </h3>
                <div className="space-y-4">
                  <div className="flex items-start">
                    <i className="ri-file-text-line text-teal-600 mr-3 mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Documento di identità</h4>
                      <p className="text-gray-700 text-sm">Carta d'identità o passaporto in corso di validità</p>
                    </div>
                  </div>
                  <div className="flex items-start">
                    <i className="ri-file-text-line text-teal-600 mr-3 mt-1"></i>
                    <div>
                      <h4 className="font-semibold text-gray-900">Codice fiscale</h4>
                      <p className="text-gray-700 text-sm">Tessera sanitaria o documento equivalente</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <h2 className="text-3xl font-bold text-white mb-4">
              Richiedi il Tuo Contratto Personalizzato
            </h2>
            <p className="text-xl text-white/95 mb-8">
              Un contratto su misura per le tue esigenze specifiche, conforme alle normative vigenti
            </p>
            <Button variant="secondary" size="lg" className="cursor-pointer bg-white text-indigo-600 hover:bg-gray-100 shadow-xl" onClick={() => setShowBooking(true)}>
              Inizia Ora
            </Button>
          </div>
        </section>
      </main>
      <Footer />
      <BookingCalendar isOpen={showBooking} onClose={() => setShowBooking(false)} />
    </div>
  );
}
